import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './IncentiveDetail';
import IncentiveDetail from './IncentiveDetail';
import { StoreState } from 'src/store/reducers';
import { getIncentive, getIncentivesEntities, updateIncentive } from 'src/store/actions/incentive-actions';
import { toast } from 'react-toastify';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.incentives.current,
        dataEntities: state.incentives.dataEntities,
        inProgress: state.incentives.inProgress,
        inProgressEntity: state.incentives.inProgressEntity,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id: string) => dispatch(getIncentive(id)),
        updateIncentive: ({ status, id, setPopup }: any) =>
            dispatch(
                updateIncentive(
                    { status, id },
                    () => {
                        toast.success('Status changed successfully');
                        setPopup(false);
                    },
                    (errorMessage: string) => {
                        setPopup(false);
                        toast.error(errorMessage);
                    },
                ),
            ),
        getIncentivesEntities: (params: { id: string | number; caseEnt: string }) =>
            dispatch(getIncentivesEntities(params)),
    };
}

const IncentiveDetailScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(IncentiveDetail);

export default IncentiveDetailScreen;
